import { PassedInitialConfig, LogLevel } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';
import { getConfig } from '../config.service';

// Build OIDC config dynamically from runtime config.json
export function createAuthConfig(): PassedInitialConfig {
  const config = getConfig();
  return {
    config: {
      // Keycloak realm endpoint
      authority: config.oidc.authority,

      // Client ID registered in Keycloak
      clientId: config.oidc.clientId,

      // Redirect URLs
      redirectUrl: config.oidc.redirectUrl,
      postLogoutRedirectUri: config.oidc.postLogoutRedirectUri,

      // OAuth scopes
      scope: config.oidc.scope,

      // Use authorization code flow with PKCE (recommended for SPAs)
      responseType: 'code',

      // Enable silent token renewal
      silentRenew: true,
      useRefreshToken: true,
      // Refresh token 60 seconds before expiry (gives buffer for network delays)
      renewTimeBeforeTokenExpiresInSeconds: 60,
      // Required for refresh token flows
      ignoreNonceAfterRefresh: true,

      // Don't auto-fetch user info - we'll do it manually after login
      autoUserInfo: false,

      // Maximum log level for debugging
      logLevel: environment.production ? LogLevel.None : LogLevel.Debug,

      // Secure token storage
      secureRoutes: [config.api.middlewareUrl],

      // Trigger events for authorization results
      triggerAuthorizationResultEvent: true,

      // Don't start implicit flow checks
      startCheckSession: false,
    },
  };
}
